import { Button } from '@packages/shared';
import { Android32 } from '@packages/themes/icons';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useShareButtonTracking } from '../Tracking/hooks/useShareButtonTracking';
import { messages } from './messages';

export type ShareButtonProps = {
  title: string;
  text: string;
};

/**
 * Displays a 'share' button on browsers that support native web-share-api
 * */
export const ShareButton = ({ title, text }: ShareButtonProps) => {
  const { trackButtonClick, trackViewButton } = useShareButtonTracking();
  const { formatMessage } = useIntl();
  const currentUrl = usePathname();

  useEffect(
    () => {
      trackViewButton();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const onClick = async () => {
    trackButtonClick();
    await window.navigator.share({ title, text, url: currentUrl ?? undefined });
  };
  return (
    <Button endIcon={<Android32 />} onClick={onClick} fullWidth>
      {formatMessage(messages.shareButtonText)}
    </Button>
  );
};
